var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.query.dialogStatus)?_c('questionbankList',{ref:"questionbankList"}):_c('questionbankList',{ref:"questionbankList",attrs:{"list-status":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }